import request from '@/utils/request'

export function getArmStrongList (data) {
  return request({
    url: '/api/v1/armstrongSetting',
    method: 'POST',
    data
  })
}

export function getSrList (data) {
  return request({
    url: '/api/v1/salesperson/list',
    method: 'POST',
    data
  })
}

export function insertArmStrongList (data) {
  return request({
    url: '/api/v1/armstrongSetting/insert',
    method: 'POST',
    data
  })
}

export function deleteAllArmStrongList (data) {
  return request({
    url: '/api/v1/armstrongSetting/delete/all',
    method: 'POST',
    data
  })
}
